import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// Get saved language from localStorage or use default
const getSavedLanguage = () => {
  const saved = localStorage.getItem('i18nextLng');
  const supportedLanguages = ['en', 'ru', 'et', 'lt', 'lv'];
  if (saved && supportedLanguages.includes(saved)) {
    return saved;
  }
  return 'lv'; // Default to Latvian
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getSavedLanguage(),
    fallbackLng: 'lv',
    supportedLngs: ['en', 'ru', 'et', 'lt', 'lv'],
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    debug: false,
    react: {
      useSuspense: true,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
